import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// F-06: street/unitNumber/city/state/zipCode live on a private subdoc the
// guest can't read directly. This callable checks server-side for a
// confirmed booking and returns the address only then.
export const getMealAddress = async (mealId) => {
  const callable = httpsCallable(functions, 'getMealAddress');
  try {
    const { data } = await callable({ mealId });
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to load the meal address.');
  }
};
